module.exports = {
  ITEMS_PER_PAGE: 30,
  SITE_TITLE: 'React HN',
  UPDATES_CACHE_SIZE: 500
}



/** WEBPACK FOOTER **
 ** ./src/utils/constants.js
 **/